module.exports = __webpack_public_path__ + "static/media/veneto-3-07.f78aa00d.jpg";